<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="6">
        <div class="display-2 text-center ma-3">Woops! Not Found</div>
        <v-img
          max-height="500"
          src="https://pbs.twimg.com/media/DGagfiRUQAAdO8I.jpg:large"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

